import {
  CHAT_IMPRESSIONS_BY_MINUTES_DIMENSIONS,
  CHAT_IMPRESSIONS_MEASURES,
  DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS,
  DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES,
  DRIFT_CHAT_PLAYBOOK_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS,
  FACT_DRIFT_CHAT_CONVERSATION_DIMENSIONS,
  PLAYBOOKS_CHAT_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const PlaybookChatCardsQuery: CubeQuery = {
  name: 'PlaybookChatCardsMetrics',
  queryName: 'PlaybookChatCardsMetrics',
  query: {
    measures: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_SENDS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_EMAILS_CAPTURED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_ROUTED_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.AVG_CQL_SCORE,
    ],
  },
}

export const PlaybookChatQuery: CubeQuery = {
  name: 'PlaybookChatMetrics',
  queryName: 'PlaybookChatMetrics',
  query: {
    measures: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_SENDS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_EMAILS_CAPTURED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_ROUTED_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.AVG_CQL_SCORE,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.SUM_CQL_SCORE,
    ],
    dimensions: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.ORG_ID,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.PLAYBOOK_ID,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_NAME,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_STATUS,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_REPORT_TYPE,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_IS_AI_ENABLED,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_WORKSPACE_ID,
    ],
  },
}

export const PlaybookChatExperimentQuery: CubeQuery = {
  name: 'PlaybookChatExperimentMetrics',
  queryName: 'PlaybookChatExperimentMetrics',
  query: {
    measures: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_IMPRESSIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_SENDS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_EMAILS_CAPTURED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.AVG_CQL_SCORE,
    ],
    dimensions: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.BOT_FLOW,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.PLAYBOOK_ID,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_NAME,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_CREATED_AT,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_STATUS,
    ],
  },
}

export const PlaybookFastlaneExperimentQuery: CubeQuery = {
  name: 'PlaybookFastlaneExperimentMetrics',
  queryName: 'PlaybookFastlaneExperimentMetrics',
  query: {
    measures: [
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_END_USER_ENGAGED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_CONVERSATION_HELD,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_FORM_FILLS,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_DISMISSED,
    ],
    dimensions: [
      FACT_DRIFT_CHAT_CONVERSATION_DIMENSIONS.IS_IN_PLAYBOOK_EXPERIMENT,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.PLAYBOOK_ID,
    ],
  },
}

export const PlaybookFastlaneExperimentSendsQuery: CubeQuery = {
  name: 'PlaybookFastlaneExperimentSends',
  queryName: 'PlaybookFastlaneExperimentSends',
  query: {
    measures: [CHAT_IMPRESSIONS_MEASURES.CHAT_IMPRESSIONS_BY_MINUTES_COUNT],
    dimensions: [CHAT_IMPRESSIONS_BY_MINUTES_DIMENSIONS.IS_EXPERIMENT],
  },
}

export const PlaybookFastlaneExperimentExportQuery: CubeQuery = {
  name: 'PlaybookFastlaneExperimentExportMetrics',
  queryName: 'PlaybookFastlaneExperimenExporttMetrics',
  query: {
    measures: [
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_END_USER_ENGAGED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_CONVERSATION_HELD,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_FORM_FILLS,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS.COUNT_DISMISSED,
    ],
    dimensions: [
      FACT_DRIFT_CHAT_CONVERSATION_DIMENSIONS.IS_IN_PLAYBOOK_EXPERIMENT,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.PLAYBOOK_ID,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.EVENT_CREATED_AT,
      DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_NAME,
      DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_STATUS,
    ],
  },
}
